import { Base } from './base';
// import { Util } from './index';

export class Server extends Base {

    constructor(settings: any = {}) {
        super();
        this.settings = settings;
    }

}
